<template>
  <div>
    <v-container fluid class="pl-5 mt-5 pt-5">
      <span class="subtitle font-weight-bold mb-5 d-inline-block">{{$t('searchableProducts.sidebar.price')}}:</span>
      <v-range-slider
              v-model="params.priceRange"
              :min="this.sliderMinRange"
              :max="this.sliderMaxRange"
              hide-details
      ></v-range-slider>
      <v-row class="range-inputs">
        <v-col col="6">
          <v-text-field
            v-model="params.priceRange[0]"
            class="mt-0 pt-0"
            hide-details
            outlined
            type="number"
            :suffix="$t('searchableProducts.sidebar.currency')"
          ></v-text-field>
        </v-col>

        <v-col col="6">
          <v-text-field
            v-model="params.priceRange[1]"
            class="mt-0 pt-0"
            hide-details
            outlined
            type="number"
            :suffix="$t('searchableProducts.sidebar.currency')"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import _ from 'lodash';
  import api from '../../../api/index';

  export default {
    props: ['params', 'layout'],
    data() {
      return {
        sliderMinRange: 1,
        sliderMaxRange: 2000,
        priceFromUrl: false,
      };
    },
    created() {
      this.fetchMaterials();
      // this.fetchSliderMaxRange(); TODO
    },
    updated() {
      if (!this.params.setMaterialsFromUrl) {
        this.searchMaterialsFromUrl();
      }
    },
    computed: {
      paginatedMaterials() {
        if (this.showAllMaterials) {
          return this.materials;
        }

        return this.materials.slice(0, 3);
      },
      paginationTranslationBrands() {
        if (!this.showAllBrands) {
          return this.$t('searchableProducts.sidebar.more');
        }

        return this.$t('searchableProducts.sidebar.less');
      },
      paginationTranslationMaterials() {
        if (!this.showAllMaterials) {
          return this.$t('searchableProducts.sidebar.more');
        }

        return this.$t('searchableProducts.sidebar.less');
      },
    },
    methods: {
      fetchMaterials() {
        api.get(`/api/v2/storefront/taxons/materials`).then(res => {
          const { data } = res;
          this.materials = data.included.filter(material => {
            return material.relationships.products.data.length > 0;
          });
        });
      },
      fetchSliderMaxRange() {
        api.get(`/api/v2/storefront/products/slider_max_range`).then(res => {
          const { data } = res;
          this.sliderMaxRange = data.max_range;
          this.params.priceRange = [1, data.max_range];
        });
      },
      togglePagination(attr) {
        if (attr === 'brands') {
          this.showAllBrands = !this.showAllBrands;
        }

        this.showAllMaterials = !this.showAllMaterials;
      },
      searchMaterialsFromUrl() {
        const searchParams = new URLSearchParams(location.search);
        const materials = searchParams.getAll('material');

        if (Boolean(materials)) {
          this.layout.materialsFromUrl = materials;
          const selectedMaterials = this.materials.filter(material => {

            return material.attributes.name && materials.map(el => el.toLowerCase()).includes(material.attributes.name.toLowerCase().toLowerCase());
          });

          if (Boolean(selectedMaterials)) {
            this.params.setMaterialsFromUrl = true;
            this.params.materials.push(...selectedMaterials);
          }

          if (selectedMaterials.length > 0) {
            this.showAllMaterials = true;
          }
        }
      },
    },
    watch: {
      searchCountries(val) {
        if (this.isLoadingCountries) return;
        this.isLoadingCountries = true;

        fetch(`/api/v1/countries?q[name_cont]=${val}&per_page=50&q[name]=desc`).then(res => res.json()).then(res => {
          const { countries } = res;
          this.countries = countries;
        }).catch(err => {
        }).finally(() => (this.isLoadingCountries = false));
      },
      'params.priceRange': {
        handler(val) {
          const url = new URL(location.href);
          url.searchParams.set('price_from', val[0]);
          url.searchParams.set('price_to', val[1]);
          history.pushState(null, '', url.toString().replace('%2F', '/'));
        }
      }
    },
  };
</script>

<style lang="scss">
  .v-input__slot {
    .v-label {
      margin-bottom: -4px !important;
    }
    font-size: 14px;
    padding: 0 8px !important;

    input[type='number'] {
      text-align: center;
    }
  }

  .clickable {
    cursor: pointer;
  }

  .range-inputs {
    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type=number] {
      -moz-appearance:textfield;
    }
  }

</style>